import { useQuery } from '@tanstack/react-query';
import { SEARCH_USERS } from '../../../../../constants/queryKeys';
import { ApiCalls } from '../../../../../api/api';
import { useStore } from '../../../../../store/useStore';
import { useEffect, useRef } from 'react';
import { TimeUser } from '../../../../../api/generated/data-contracts';
import shallow from 'zustand/shallow';

export const useSearchUsers = () => {
    const { searchText, setCurrentUsers, setOriginalUsers } = useStore(
        state => ({ searchText: state.searchText, setCurrentUsers: state.setCurrentUsers, setOriginalUsers: state.setOriginalUsers }),
        shallow,
    );

    const defaultData = useRef([] as TimeUser[]).current;

    // Then search users and merge with calendar data
    const { data: users = defaultData, isFetching: isFetchingSearch } = useQuery({
        queryKey: [SEARCH_USERS, searchText],
        queryFn: () => ApiCalls.searchUsers({ searchText }).then(({ data }) => data),
    });

    useEffect(() => {
        const sortedUsers = users.toSorted((a, b) => a.name?.localeCompare(b.name));
        setCurrentUsers(sortedUsers);
        setOriginalUsers(sortedUsers);
    }, [setCurrentUsers, setOriginalUsers, users]);

    const isFetching = isFetchingSearch;

    return { isFetching, users };
};
